import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Modal, Select } from 'antd';
import * as actions from '../redux/actions/agents';

class AddAgentProduct extends React.Component {

    state = {
        confirmLoading: false,
    }
    layout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };

    onFinish = async (values) => {
        let agentProduct = {
            productId: values.product,
            unitPrice: values.unitPrice,
            extraCommission: values.extraCommission,
        }
        await this.props.onAdd(this.props.agentDetail.id, agentProduct, this.props.token);
        this.setState(prevState => {
            return {
                ...prevState,
                confirmLoading: true,
            }
        });
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    ...prevState,
                    confirmLoading: false,
                }
            });
            this.props.onCloseForm();
        }, 200);
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel = () => {
        this.props.onCloseForm();
    }
    render() {
        const { Option } = Select;
        let products = this.props.products.map(product => {
            return (
                <Option key={product.id} value={product.id}>{product.name}</Option>
            );
        })
        return (
            <Modal
                title="Add Agent Product"
                key={this.props.agentDetail.id}
                centered
                visible={this.props.addVisible}
                okButtonProps={{ form: 'add-agentProduct-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="add-agentProduct-form"
                    {...this.layout}
                    name="basic"
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="product"
                        label="Product"
                        rules={
                            [{
                                required: true,
                                message: 'Require product id',
                            }]
                        }
                    >
                        <Select
                            style={{ width: 180 }}
                        >
                            {products}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="unitPrice"
                        label="Unit Price"
                        rules={[
                            {
                                required: true,
                                message: 'Require unit price!',
                            },

                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="extraCommission"
                        label="Extra commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require extra commission!',
                            },

                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        addVisible: state.agents.addAgentProductVisible,
        agentDetail: state.agents.agentDetail,
        products: state.products.products,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeAgentProductAdd()),
        onAdd: (id, agentProduct, token) => dispatch(actions.addAgentProduct(id, agentProduct, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddAgentProduct);